import { defineSlotRecipe } from '@chakra-ui/react'

export const dashboardControlRecipe = defineSlotRecipe({
  className: 'dashboard-control',
  slots: ['root', 'item', 'handle', 'preview'],
  base: {
    root: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '8',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'transparent',
      borderRadius: 'l2',
      background: 'transparent',
      padding: '2',
      cursor: 'default',
      transitionProperty: 'background, border-color, box-shadow, opacity, transform',
      transitionDuration: 'normal',
      transitionTimingFunction: 'ease-in-out',
      _hover: {
        boxShadow: 'sm',
      },
      '&[data-dragging]': {
        background: 'bg.muted',
        borderStyle: 'dashed',
        borderColor: 'border.emphasized',
        boxShadow: 'md',
        opacity: 0.3,
      },
    },
    handle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1',
      borderRadius: 'l2',
      cursor: 'grab',
      transitionProperty: 'background',
      transitionDuration: 'fast',
      transitionTimingFunction: 'ease-in-out',
      _hover: {
        background: 'bg.muted',
      },
      '&[data-dragging]': {
        background: 'bg.emphasized',
        cursor: 'grabbing',
      },
      _active: {
        cursor: 'grabbing',
      },
    },
    preview: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '8',
      borderWidth: '2px',
      borderStyle: 'dashed',
      borderColor: 'border.emphasized',
      borderRadius: 'l2',
      background: 'bg.panel',
      padding: '2',
      boxShadow: 'lg',
    },
  },
})
